import React, { FunctionComponent } from 'react';

import styles from './TwitterPostCardStatus.module.scss';
import { nFormatter } from 'app/utils/numbersFormater';
import { _t } from 'app/utils/i18n';

interface Props {
  tweetStatus: {
    retweets_count: number;
    replies_count: number;
    likes_count: number;
    bookmarks_count?: number;
    views?: number;
  };
  isReport?: boolean;
}

const TwitterPostCardStatus: FunctionComponent<Props> = ({
  tweetStatus: {
    likes_count,
    replies_count,
    retweets_count,
    bookmarks_count,

    views,
  },
  isReport,
}) => {
  return (
    <div className={styles.TwitterPostCardStatus}>
      <div>
        <span>{nFormatter(retweets_count)}</span>
        <span>{_t('hashtags:retweets')}</span>
      </div>
      {replies_count > 0 || isReport ? (
        <div style={{ display: isReport ? 'none' : 'block' }}>
          <span>{nFormatter(replies_count)}</span>
          <span>{_t('basic:reply')}</span>
        </div>
      ) : (
        <></>
      )}
      {isReport ? (
        <div style={{ display: 'none' }}>
          <span>{nFormatter(views)}</span>
          <span>{_t('basic:views')}</span>
        </div>
      ) : (
        <></>
      )}
      <div>
        <span>{nFormatter(likes_count)}</span>
        <span>{_t('trends:likes')}</span>
      </div>
      {bookmarks_count !== undefined && (
        <div>
          <span>{nFormatter(bookmarks_count)}</span>
          <span>{_t('trends:bookmarks')}</span>
        </div>
      )}
    </div>
  );
};

export default TwitterPostCardStatus;
